
export function formatTimeFromSeconds(secs) {
    var options = {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    };
    const time = new Date(secs * 1000);
    return time.toLocaleTimeString(undefined, options);
}
